import React from 'react';
import { Menu } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { cn } from '../../utils/cn';

const SidebarToggle = () => {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <button
      onClick={toggleSidebar}
      className={cn(
        "p-2 rounded-lg transition-colors",
        "hover:bg-slate-100",
        "focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
      )}
      aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      <Menu className="w-5 h-5 text-slate-600" />
    </button>
  );
};

export default SidebarToggle;